module.exports = __webpack_public_path__ + "static/media/Jon-Favreau-Crooked-Media.2bf9663e.png";